/**
 * Action Types
 */

export const Types = {
    ADD: 'user/ADD_USER',
    REMOVE: 'user/REMOVE_USER'
};

/**
 * Reducer
 */
const INITIAL_STATE = {};

export default function user(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.ADD:
            return { ...state, ...action.payload };

        case Types.REMOVE:
            return null;
        default:
            return state;
    }
}

/**
 * Action Creators
 */

export const Creators = {
    userAdd: (payload) => ({
        type: Types.ADD,
        payload
    }),

    userRemove: () => ({
        type: Types.REMOVE
    })
};
